module.exports = __webpack_public_path__ + "img/pin-user.04150cd1.svg";